/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useContext, useState,useCallback,useEffect} from 'react'
import GlobalContext from '../../../components/Context/GloablContext'
import Loader from '../../../components/Loader'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { dataService } from '../../../services/data.services'
import CustomOverLay from '../../../components/CustomOverlay'
import CardHeader from '../../../components/CardHeader'
import Toast from '../../../components/Toast'
import moment from 'moment'
import AddAcademicYear from '../../../components/ManageAcademicYear/AddAcademicYear'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import { GetBranchId } from '../../../CommonMethods/GetBranchId'

export default function AddNewAcademicYear({edit}) {
    
    const {setToastmessage}=useContext(GlobalContext)
    const location = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams('')
    const {academic_year_id } = useParams();
    const navigate=useNavigate()
    const [editData, seteditData] = useState({})
    const [submitSelected, setsubmitSelected] = useState(false);
    const [loading, setloading] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [responseStatus,setResponseStatus]=useState('')
    const [originalEditDates,setOriginalEditDates]=useState({
        "original_start_date":"",
        "original_end_date":"",
        "original_status":""
    })
    const initialState={
        "academic_year_name":"",
        "academic_year_status":"Draft",
        "start_date":"",
        "end_date":"",
        "disable_status":false,
        "disable_start_date":false,
        "disable_end_date":false
    }
    const [addAcademicYearState, setAddAcademicYearState] = useState(initialState);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false);
    const [activateOpen, setActivateOpen] = useState(false);



    const handleValidation = () => {
        const arr = [];
        const mykeys = {
            "academic_year_name": "",
            "start_date": "",
            "end_date": "",
        };
        Object.keys(mykeys).map((item) => {
            if (addAcademicYearState[item] === "") {
                arr.push(item);
            }
        });
        return arr?.length === 0;
    };
    function formatDateTodisplay(inputDate) {
        const dateParts = inputDate.split("-");
        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]);
        const day = parseInt(dateParts[2]);

        const months = [
            "Jan", "Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",
        ];

        const formattedDate = `${months[month - 1]} ${day}, ${year}`;
        return formattedDate;
    }
    
    const handleFetch = useCallback(async () => {
        let response = await dataService.GetAPI(`academic-years/${academic_year_id}`);
        if (response?.data?.status === 200) {
            const Getdata = response.data.data;
            seteditData(JSON.parse(JSON.stringify(Getdata)));

            setAddAcademicYearState((prv)=>({
                ...prv,
                academic_year_name: Getdata.name,
                academic_year_status:
            Getdata.status === "draft"
                ? "Draft"
                : Getdata.status === "ongoing"
                    ? "Ongoing AY"
                    : "Upcoming AY",
                start_date: formatDateTodisplay(Getdata.start_date),
                end_date: formatDateTodisplay(Getdata.end_date),
            }));
            setOriginalEditDates((prv)=>({
                ...prv,
                original_start_date :formatDateTodisplay(Getdata.start_date),
                original_end_date : formatDateTodisplay(Getdata.end_date),
                original_status : Getdata.status === "draft"? "Draft": Getdata.status === "ongoing"? "Ongoing AY": "Upcoming AY"

            }))
            
        
        }},[academic_year_id]);
    
    useEffect(() => {
        if (edit) handleFetch();
        
    }, [handleFetch]);
  
    
    const handleConformationClick = () => {
        setAddAcademicYearState((prv)=>({
            ...prv,
            academic_year_status:originalEditDates.original_status
        }))
        setActivateOpen(false)
    };

    const handleOnCLickComplete = async () => {
        setActivateButtonLoading(true);
        try {
            let body = {};
            body = {
                status: "completed",
            };
            let endpoint = `academic-years/${academic_year_id}`;
            const response = await dataService.PatchAPI(body, endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setActivateOpen(false)
            navigate('/manage-academic-years')
            setToastmessage("This AY is marked as completed. No further changes are allowed.");
        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
    };
    
   
    function compareDates(dateStr1, dateStr2) {
        // Split date strings into day, month, and year parts
        const [day1, month1, year1] = dateStr1.split("-").map(Number);
        const [day2, month2, year2] = dateStr2.split("-").map(Number);

        // Create Date objects from the parts (months are 0-indexed in JavaScript's Date)
        const date1 = new Date(year1, month1 - 1, day1);
        const date2 = new Date(year2, month2 - 1, day2);

        // Compare the dates
        if (date1 > date2) {
            return true; 
        }
    }
    function formatDate(inputDate) {
        // Parse the input date using the original format
        const parsedDate = new Date(inputDate);

        // Extract day, month, and year
        const day = parsedDate.getDate().toString().padStart(2, "0");
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
        const year = parsedDate.getFullYear();

        // Create the formatted date string
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
    }
    const onBlur = event => {
        if(compareDates(formatDate(addAcademicYearState.start_date),formatDate(addAcademicYearState.end_date))){
            setloading(false)
            setToastErrorMessage('Start Date cannot exceed End Date')
            setResponseStatus('dateError')
        }
    }
    const handleSubmit = async () => {
        // e.preventDefault();
        setloading(true);
        setToastErrorMessage('');
        setsubmitSelected(true);
    
        if (!handleValidation()) {
            setloading(false);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
    
        if (compareDates(formatDate(addAcademicYearState.start_date), formatDate(addAcademicYearState.end_date))) {
            setloading(false);
            setToastErrorMessage("Start Date cannot exceed End Date");
            setResponseStatus('dateError');
            return;
        }
    
        if (addAcademicYearState.academic_year_name.trim() === "") {
            setloading(false);
            setToastErrorMessage("Please fill in all the mandatory fields");
            setResponseStatus('409');
            return;
        }
    
        try {
            let {
                academic_year_name,
                academic_year_status,
                start_date,
                end_date,
            } = addAcademicYearState;
    
            let branch_id = await GetBranchId();
    
            let body = {
                name: academic_year_name.trim(),
                start_date: moment(start_date).format("YYYY-MM-DD"),
                end_date: moment(end_date).format("YYYY-MM-DD"),
                status: addAcademicYearState.academic_year_status === "Draft" ? "draft" :
                    addAcademicYearState.academic_year_status === "Ongoing AY" ? "ongoing" : "upcoming",
                branch_id: branch_id,
            };
    
            let response;
    
            if (edit) {
                if (addAcademicYearState.academic_year_status === "Draft") {
                    body = {
                        name: academic_year_name.trim(),
                        start_date: moment(start_date).format("YYYY-MM-DD"),
                        end_date: moment(end_date).format("YYYY-MM-DD"),
                        status: "draft",
                    };
                } else if (addAcademicYearState.academic_year_status === "Ongoing AY") {
                    body = {
                        name: academic_year_name.trim(),
                        status: "ongoing",
                    };
                } else {
                    body = {
                        name: academic_year_name.trim(),
                        status: "upcoming",
                    };
                }
                response = await dataService.PatchAPI(body, `academic-years/${academic_year_id}`);
            } else {
                response = await dataService.PostAPI(body, `academic-years`);
            }
    
            setToastmessage(`Academic year ${edit ? "updated" : "added"} successfully`);
            edit ? location(`/manage-academic-years?${searchParams.toString()}`) : location("/manage-academic-years")
        } catch (error) {
            console.log("error",error);
            setloading(false);
            setResponseStatus(JSON.stringify(error?.response?.status));
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
    };
    

    
    
    return (
        <>
            <CardHeader noPadding classkey={'overflow-y-hidden'}>
                <div
                    class="mainDataCntnrTop shadow-s13"
                    style={{ position: "sticky", position: -"webkit-sticky;" }}
                >
                    <h5 class="pageHeader adderror">
                        {edit ? "Edit" : "Add"} Academic Year
                    </h5>
                    <div class="flex items-center">
                        <button
                            onClick={() => edit ? location(`/manage-academic-years?${searchParams.toString()}`) : location("/manage-academic-years")}
                            type="button"
                            class="cancl-btn"
                        >
                            Cancel
                        </button>
                        <button
                            disabled={loading || (edit && Object.keys(editData)?.length === 0)}
                            onClick={() => handleSubmit()}
                            className="actn-btn onboardInstitution"
                        >
                            {!loading ? (edit ? "Update" : "Add") : <span>{<Loader />}</span>}
                        </button>
                    </div>
                </div>
                {edit && Object.keys(editData)?.length===0 && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
                {!(edit && Object.keys(editData)?.length===0) && <AddAcademicYear
                    academicState={addAcademicYearState}
                    setAddAcademicYearState={setAddAcademicYearState}
                    status={responseStatus}
                    setResponseStatus={setResponseStatus}
                    submitSelected={submitSelected}
                    setsubmitSelected={setsubmitSelected}
                    onBlur={onBlur}
                    edit={edit}
                    originalEditDates={originalEditDates}
                    setActivateOpen={setActivateOpen}
                    setToastErrorMessage={setToastErrorMessage}
                />}
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </CardHeader>
            {edit && activateOpen&&addAcademicYearState.academic_year_status==="Completed" &&
               ( <AnimatedModel
                   Children={
                       <ConfirmationPrompt
                           handleOnCLickActivate={handleOnCLickComplete}
                           handleClose={handleConformationClick}
                           tittle={"Mark as Completed"}
                           message={"Would you like to proceed?"}
                           buttonName="Proceed"
                           loadingActivation={activateButtonLoading}
                           additionalMessage="Once the status is set to 'Completed', you cannot add or modify any of the data for the Academic Year."
                           dialogueWidth={'500px'}
                           textPosition={'text-start'}
                       />
                   }
               />)
                
        
            }
        </>
        
    );
}
